import { useSelector as _useSelector } from 'react-redux';
import { type RootState } from '../core/root.state';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- TState allows interface segregation for testing (e.g., using SubsetState)
export type UseSelector = <TSelected, TState = RootState>(
  selector: (state: TState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
) => TSelected;

export const useSelector: UseSelector = (...args) => {
  return _useSelector(...args);
};
